import Modal from './Modal';


Modal.install = function(Vue) {
  Vue.component(Modal.name, Modal);
};

export default Modal;
